module.exports = "/assets/js/3ce6a28ee908043529b1ce417664495a.svg";